import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiRequest from '../../api/request'
import { formatDataForDataTable } from "../../utils/formatData";

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  dashboardCounts: {},
  departments: [],
  employees: [],
  grievanceJourney:[],
  coursePurchase:{},
  activeCourses:[],
  purchaseData:{},
  portalLeads: {},
  // Per-lead assessment detail for the drawer. `leadAssessmentLoading` is its
  // own flag rather than the shared `loading`, so opening the drawer does not
  // put the grid behind it into a loading state.
  leadAssessment: null,
  leadAssessmentLoading: false,
}
export const getAllGrievancesDashboardCounts = createAsyncThunk(
  'studentPortalSlice/getAllGrievancesDashboardCounts',
  async () => {
    const res = await apiRequest({
      method: 'get',
      url: `grievance/dashboard-count`,
    })
    return res
  },
)

export const getAllGrievancesTickets = createAsyncThunk(
  'studentPortalSlice/getAllGrievancesTickets',
  async (dispatchParams) => {
    const { grievenceTypeId, paginationData, status,fromDate,toDate } = dispatchParams
     
      let statusFilter = 'filters[status]=equals:'
      let grievanceFilter = 'filters[type]=equals:'

      if(status?.length>0){
        statusFilter += status.map((Name)=>`${Name}`).join(encodeURIComponent('+'))
      }
      if(grievenceTypeId?.length>0){
        grievanceFilter += grievenceTypeId.map((id)=>`${id}`).join(encodeURIComponent('+'))
      }
    const url = `grievance/?page=${paginationData?.pageNum}&limit=${
      paginationData?.gridSize
    }&search=${encodeURIComponent(paginationData?.search)}${status?.length>0 ? `&${statusFilter}`:""}${grievenceTypeId?.length>0?`&${grievanceFilter}`:""}${fromDate?`&filters[createdDate]=greater_than_or_equal:${fromDate}`:""}${toDate?`&filters[createdDate]=less_than_or_equal:${toDate}`:""}`
    const res = await apiRequest({
      method: 'get',
      url:url,
    })
    return res
  },
)


export const getGrievancesJourney = createAsyncThunk(
  'studentPortalSlice/getGrievancesJourney',
  async (id) => {
    const res = await apiRequest({
      method: 'get',
      url: `grievance/${id}`,
    })
    return res
  },
)

export const getAllDepartments = createAsyncThunk('studentPortalSlice/getAllDepartments', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `departments/`,
  })
  return res
})

export const getEmployeesUnderTheDepartment = createAsyncThunk(
  'studentPortalSlice/getEmployeesUnderTheDepartment',
  async (id) => {
    const res = await apiRequest({
      method: 'get',
      url: `general/empolyee-under-department/${id}?limit=no`,
    })
    return res
  },
)

export const updateAssignation =createAsyncThunk('studentPortalSlice/updateAssignation', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `grievance/assign/${data.id}`,
    data: data,
  })
  return res
});

export const getCoursePurchaseRequest = createAsyncThunk(
  'studentPortalSlice/getCoursePurchaseRequest',
  async () => {
    const res = await apiRequest({
      method: 'get',
      url: `student-portal/get-course-purchase-request`,
    })
    return res
  }
);

export const assignRequestToCRO = createAsyncThunk(
  'studentPortalSlice/assignRequestToCRO',
  async ({croID , reqID}) => {
    const res = await apiRequest({
      method: 'patch',
      url: `student-portal/assign-cro?cro_id=${croID}&request_id=${reqID}`,
    })
    return res
  }
);

export const rejectRequest = createAsyncThunk(
  'studentPortalSlice/rejectRequest',
  async (data) => {
    const res = await apiRequest({
      method: 'patch',
      url: `student-portal/reject-request`,
      data:data
    })
    return res
  }
);

export const getActiveEnrollments = createAsyncThunk(
  'studentPortalSlice/getActiveEnrollments',
  async (admno) => {
    const res = await apiRequest({
      method: 'get',
      url: `student-portal/get-student-enrollments/${admno}`,
    })
    return res
  }
);

export const getStudentPortalLeads = createAsyncThunk(
  'studentPortalSlice/getStudentPortalLeads',
  async (searchParams) => {
  const res = await apiRequest({
    method: 'get',
    url: `prospect-leads/lsq-leads/32?page=${searchParams.page}&limit=${searchParams.limit}&search=${searchParams.search}`,
  });
  return res;
  }
);


// Level-wise scores and the question-wise attended/correct report for one lead.
// Kept out of the grid query on purpose: it is two extra table reads per lead
// and is only ever needed for the one row an employee actually opens.
export const getProspectLeadAssessment = createAsyncThunk(
  'studentPortalSlice/getProspectLeadAssessment',
  async (prospectLeadId) => {
    const res = await apiRequest({
      method: 'get',
      url: `prospect-leads/${prospectLeadId}/assessment`,
    });
    return res;
  }
);

const studentPortalSlice = createSlice({
  name: 'studentPortalSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //..................GETING ALL TICKETS ................
    builder.addCase(getAllGrievancesTickets.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      }
    })

    builder.addCase(getAllGrievancesTickets.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          data: action.payload?.data,
          meta: action.payload?.meta,
        },
      }
    })

    //..................GETING ALL DASHBOARD COUNTS ................
    builder.addCase(getAllGrievancesDashboardCounts.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      }
    })

    builder.addCase(getAllGrievancesDashboardCounts.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        dashboardCounts: action.payload?.data,
      }
    })
    //...............................GET ALL DEPARTMENTS......................//
    builder.addCase(getAllDepartments.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      }
    })
    builder.addCase(getAllDepartments.fulfilled, (state, action) => {
      return {
        ...state,
        departments: action.payload?.data?.departments,
        loading: false,
      }
    })

        //...............................GET ALL Grievance Journey......................//
        builder.addCase(getGrievancesJourney.pending, (state, action) => {
          return {
            ...state,
            loading: true,
          }
        })
        builder.addCase(getGrievancesJourney.fulfilled, (state, action) => {
          return {
            ...state,
            grievanceJourney: action.payload?.data,
            loading: false,
          }
        })
    //...............................GET ALL EMPLOYEES UNDER DEPARTMENT......................//
    builder.addCase(getEmployeesUnderTheDepartment.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      }
    })
    builder.addCase(getEmployeesUnderTheDepartment.fulfilled, (state, action) => {
      return {
        ...state,
        employees: action.payload?.data,
        loading: false,
      }
    })


       //............... UPDATE ASSIGNATION ...........................
       builder.addCase(updateAssignation.pending, (state, action) => {
        return {
          ...state,
          loading: true,
        }
      })
  
      builder.addCase(updateAssignation.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
        }
      })
      // ------------------ GET COURSE PURCHASE REQUEST ------------------------------
      builder.addCase(getCoursePurchaseRequest.pending, (state, action) => {
        return {
          ...state,
          loading: true,
        }
      })
      builder.addCase(getCoursePurchaseRequest.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          coursePurchase: formatDataForDataTable(action.payload?.data?.requests),
          purchaseData: action.payload?.data,
        }
      });
      // ------------------ ASSIGN REQUEST TO CRO ------------------------------
      builder.addCase(assignRequestToCRO.pending, (state, action) => {
        return {
          ...state,
          loading: true,
        }
      })
      builder.addCase(assignRequestToCRO.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
        }
      })
      builder.addCase(rejectRequest.pending, (state, action) => {
        return {
          ...state,
          loading: true,
        }
      })
  
      builder.addCase(rejectRequest.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
        }
      });

      builder.addCase(getActiveEnrollments.pending, (state, action) => {
        return {
          ...state,
          loading: true,
        }
      })
      builder.addCase(getActiveEnrollments.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          activeCourses: action.payload?.data,
        }
      });
      builder.addCase(getStudentPortalLeads.pending, (state) => {
        return {
          ...state,
          loading: true,
        }
      })
      builder.addCase(getStudentPortalLeads.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          portalLeads: action.payload,
        }
      })
      builder.addCase(getProspectLeadAssessment.pending, (state) => {
        return {
          ...state,
          leadAssessmentLoading: true,
          // Cleared on every open so the drawer cannot briefly show the
          // previous lead's answers while the new ones are in flight.
          leadAssessment: null,
        }
      })
      builder.addCase(getProspectLeadAssessment.fulfilled, (state, action) => {
        return {
          ...state,
          leadAssessmentLoading: false,
          leadAssessment: action.payload?.data || null,
        }
      })
      builder.addCase(getProspectLeadAssessment.rejected, (state) => {
        return {
          ...state,
          leadAssessmentLoading: false,
          leadAssessment: null,
        }
      })
  },
})

export default studentPortalSlice.reducer
